import Axios from "axios";
import axiosRetry from "axios-retry";
import { eventApiKey, eventApiUrl } from "../config/apiUrl";

const STATUS = {
  SUCCESS: 200,
  FORBIDDEN: 403,
  ERROR: "error",
};

const apiResponse = {
  status: STATUS,
  data: null,
  error: null,
};

let headerForEvent, fireAnalyticsEventClient;

const initApiClients = () => {
  headerForEvent = {
    "Content-Type": "application/json",
    "x-api-key": eventApiKey,
    "User-Agent": "okhttp",
  };
  fireAnalyticsEventClient = Axios.create({
    baseURL: eventApiUrl,
    headers: headerForEvent,
  });
  axiosRetry(fireAnalyticsEventClient, {
    retries: 0,
    retryDelay: (retryCount) => 300,
    retryCondition: () => true,
  });
};

initApiClients();

const callAPIs = async (apiMethodToCall) => {
  try {
    const response = { ...(await apiMethodToCall) };
    apiResponse.status_code = response.status;
    if (response.data.has_error_happened) {
      apiResponse.status = STATUS.ERROR;
      apiResponse.error = response.data.error;
      return apiResponse;
    } else {
      apiResponse.status = STATUS.SUCCESS;
      apiResponse.data = response.data;
      return apiResponse;
    }
  } catch (error) {
    if (error.response) {
      apiResponse.data = error.response.data;
      apiResponse.status_code = error.response.status;
    }
    apiResponse.status = STATUS.ERROR;
    apiResponse.error = error.toString();
    return apiResponse;
  }
};

const apiDebounce = (func) => {
  let loading;
  return async function () {
    const context = this;
    const args = arguments;
    if (loading) return;
    loading = true;
    await func.apply(context, args);
    loading = false;
  };
};

function sendEventData(json) {
  return fireAnalyticsEventClient.post("log_event/", json);
}

export default {
  STATUS,
  initApiClients,
  callAPIs,
  apiDebounce,
  sendEventData,
};
